import React, { Component } from 'react';
import classNames from 'classnames'
import styles from './index.css';

class MyLinkOut extends Component {
  render() {
    return ( 
      //TODO добавить пропс с типом href
        <a className={classNames(styles['myLink'], this.props.classStyle)} href={this.props.to} target="_blanck">
          {this.props.text || this.props.children}
        </a>
    );
  }
}
  
export default MyLinkOut;


// WEBPACK FOOTER //
// ./src/blocks/MyLinkOut/index.js